import React, { ReactElement } from 'react'
import classNames from 'classnames'

export function TopDisruptor(props: {
  displayedKey: string
  value: string
  additionalClassName?: string
}): ReactElement {
  return (
    <div className={classNames('flex gap-2', props.additionalClassName)}>
      <div className="flex h-[24px] whitespace-nowrap rounded text-xxs font-medium">
        <div className="font-secondary-text-color relative rounded-l bg-primary-lightened pb-1 pl-2 pr-4 pt-[5px]">
          <span>{props.displayedKey}</span>
          <div className="absolute -right-[8px] top-[3.75px] h-[15.5px] w-[15.5px] rotate-45 bg-white"></div>
        </div>
        <div className="z-20 rounded-r border-y border-r border-y-primary-lightened border-r-primary-lightened bg-white py-1 pr-2">
          {props.value}
        </div>
      </div>
    </div>
  )
}
